<template>
  <el-dialog
    :title="(isEdit ? '编辑' : '添加') + '仓库信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="仓库名称" prop="WarehouseName">
            <el-input
              v-model="form.WarehouseName"
              placeholder="仓库名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="仓库类型" prop="WarehouseType">
            <RemoteSelect
              v-model="form.WarehouseType"
              url="DataDic/GetItemsByType?dicType=WareHouseType"
              code="DicCode"
              name="DicName"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="总空间" prop="TotalSpace">
            <el-input
              v-model="form.TotalSpace"
              placeholder="总空间"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="管理员" prop="Manager">
            <RemoteSelect
              v-model="form.Manager"
              url="User/GetOrgUserList"
              code="Username"
              name="Username"
            ></RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="存储单位" prop="StorageUnit">
            <RemoteSelect
              v-model="form.StorageUnit"
              url="DataDic/GetItemsByType?dicType=CommonUnit"
              code="DicName"
              name="DicName"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="Remark">
            <el-input
              v-model="form.Remark"
              placeholder="备注"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
  
<script>
export default {
  props: ["item"],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      rules: {
        WarehouseName: [
          {
            required: true,
            message: "不可为空",
          },
        ],
        WarehouseCode: [
          {
            required: true,
            message: "不可为空",
          },
        ],
        WarehouseType: [
          {
            required: true,
            message: "不可为空",
          },
        ],
        TotalSpace: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validNumber,
        ],
        manager: [
          {
            required: true,
            message: "不可为空",
          },
        ],
        StorageUnit: [
          {
            required: true,
            message: "不可为空",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        if (v.WarehouseId) {
          this.isEdit = true;
          this.$get("WareHouse/GetModel", {
            WarehouseId: v.WarehouseId,
          }).then((r) => {
            this.init({ ...r.Result });
          });
        } else {
          this.init({});
          this.isEdit = false;
        }
        this.visible = true;
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let params = { ...this.form };
        this.loading = true;
        if (this.isEdit) {
          this.$post("WareHouse/Edit", params).then((r) => {
            this.$message.success("修改成功");
            this.visible = false;
            this.$emit("success");
          });
        } else {
          this.$post("WareHouse/Add", params).then((r) => {
            this.$message.success("添加成功");
            this.visible = false;
            this.$emit("success");
          });
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>